import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Hero from '../../components/pages/Home/Hero/Hero'
import Legacy from '../../components/pages/Home/Legacy/Legacy'
import ProjectHighlight from '../../components/pages/Home/ProjectHighlight/ProjectHighlight'
import Modern from '../../components/pages/Home/Modern/Modern'
import Strategic from '../../components/pages/Home/Strategic/Strategic'
import Footer from '../../components/shared/Footer/Footer'

const Home = () => {
  return (
    <div>
        <Navbar/>
        <Hero/>
        <Legacy/>
        <ProjectHighlight/>
        <Modern/>
        <Strategic/>
        <Footer/>
    </div>
  )
}

export default Home